import { Card, Flex, Text, Button } from '@applyboard/crystal-ui';
import { BulkChangeStatusModal } from './BulkChangeStatusModal';
import { useSelectedIntakes } from '~/context';

export const SelectedIntakesBar = () => {
  const { selectedIntakes, clear } = useSelectedIntakes();
  if (selectedIntakes.length === 0) return null;

  return (
    <Card variant="highlighted">
      <div aria-label="Selected intakes actions" role="toolbar">
        <Flex direction="column" gap={4}>
          <Flex gap={2} align="center">
            <Flex.Item grow={1}>
              <Text variant="labelM">
                {selectedIntakes.length === 1 ? '1 item' : `${selectedIntakes.length} items`} selected
              </Text>
            </Flex.Item>

            <Flex.Item>
              <Flex gap={2}>
                <BulkChangeStatusModal />
                <Button onClick={() => clear()} variant="transparent">
                  Cancel
                </Button>
              </Flex>
            </Flex.Item>
          </Flex>
        </Flex>
      </div>
    </Card>
  );
};
